import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { SchoolModuleBatch, SchoolModuleEvent } from 'src/app/models/module/moduledetails';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
declare const $: any;

@Component({
  selector: 'app-modulestudentlist',
  templateUrl: './modulestudentlist.component.html',
  styleUrls: ['./modulestudentlist.component.css'],
})
export class ModulestudentlistComponent implements OnInit {
  constructor(
    public modulemanager: ModulemanagementService,
    public toastr: ToastrService,
    public headerinfo: ComponentheaderService,
    public router: ActivatedRoute,
    public route: Router,
  ) {
    headerinfo.setHeaderDisplay(`Course Students List`, [], []);
  }
  p: number = 1;
  students: any;
  stats: any;
  itemsPerPage = 25;
  totalItems: any;
  data: any;
  moduleid: number;
  allowBatches: false;
  moduleBatches: SchoolModuleBatch[] = [];
  batchFilterActions: AdminAction[] = [];
  count: number;
  //filteredStudents: any[];
  //activeFilterId: number = 0;
  filterOptions: any;
  removeColumn = ["count", "passed", "completedLessons"];
  selectedBatchId: number = 0;
  schdata: any;
  adminActions: AdminAction[] = [];

  @ViewChild('actionslink') actionsLink: ElementRef;

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.moduleid = this.router.snapshot.queryParams.moduleid; 
    this.adminActions.push({displaytext: 'Export', callback: this.export.bind(this), classes: ['fas', 'fa-cloud-download-alt']});   
    this.headerinfo.setHeaderDisplay(
      `Course Students`,
      [
        {
          displaytext: 'School',
          route: `/user/schoolhome`,
          //params: { moduleID: this.moduleid },
        },
        {
          displaytext: 'Course',
          route: `/user/moduledetails`,
          params: { moduleID: this.moduleid },
        },
        {
          displaytext: `Registered Students`,
          route: `/user/modulestudentlist`,
          params: this.router.snapshot.queryParams,
        },
      ],
      this.adminActions
    );
    this.headerinfo.pageLoadingDone(this);
  }

  export() {
    // this.modulemanager.downloadModuleStudentList(this.moduleid).subscribe();
    this.headerinfo.pageLoadingStarted(this);
    try {

    this.modulemanager
    .downloadModuleStudent(this.moduleid)
    .subscribe((response: any) => {
      const url = window.URL.createObjectURL(response);
      window.open(url);

    }),
    (error: any) => console.log('Error downloading the file'),
    () => console.info('File downloaded successfully');
    } catch (error) {

    }finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }
  
  async loadTableData(eventData){
    try{
      this.headerinfo.pageLoadingStarted(this);
      this.schdata = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();

      this.allowBatches = this.schdata?.allowBatches;
      if (this.allowBatches){
        this.moduleBatches = await this.modulemanager.getModuleBatches(this.moduleid).toPromise();
  
        let defaultBatchAction = new AdminAction();
        defaultBatchAction.displaytext = "All Batches";
        defaultBatchAction.params = {id: 0}
        this.batchFilterActions.push(defaultBatchAction);
        this.moduleBatches.forEach(b => {
          let obj = new AdminAction();
          obj.displaytext = b.name;
          obj.params = {id: b.id};
          if (!this.batchFilterActions.find(a => a.displaytext == b.name))
            this.batchFilterActions.push(obj);
        });
      };

      this.data = await this.modulemanager
        .getModuleStudents(this.moduleid, eventData.page, eventData.offset, this.setFilterData(eventData))
        .toPromise()
        .catch((err) => {
          this.toastr.error(err);
          this.route.navigate(['/user/moduledetails'], {
            queryParams: { moduleID: this.moduleid },
          });
          return;
        })
        .finally(() => this.headerinfo.pageLoadingDone(this));
      
      this.setResult(eventData);
      if (!this.students || this.students?.length == 0) {
        this.toastr.error(`No Student enrolled`);
        return;
      }            
    }
    catch(e){
      console.log(e)
    }
    finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }
  setResult(eventData) {
    this.students = this.data;
    this.students.length > 0 ? this.count = this.students[0].count : 0;    
    eventData.filters?.length > 0 ? this.filterOptions = eventData.filters : this.loadFilterOptions();
  }
  setFilterData(eventData) {
    let filterParams = [];

    if (eventData?.filters) {
      for (let f of eventData.filters) {
        //get dropdown values
        if (f["value"] && f["dropdown"] == true)
          filterParams.push({ value: f["value"], param: f["param"] });
        //get datetime values
        if (f["value"] && f["date"] == true)
          filterParams.push({ value: new Date(f["value"]).toISOString(), param: f["param"] });
      }
    }

    return filterParams;
  }
  loadFilterOptions() {
    this.filterOptions = new Array();    
    if(this.schdata?.allowBatches){
      this.filterOptions.push(
        { param: 'Batch', dropdown: true, date: false,
          label: "Batch", dropdownOptions: this.batchFilterActions.map(item => {
            return { displaytext: item.displaytext, value: item.params.id }})
        },
      );
    }    
  }
}
